export enum LDFlags {
  SHOW_ALTERNATE_WALLET_LOGO = 'showAlternateWalletLogo',
}
